// Only ingredient-link configuration belongs in a parent product's request.
export function ingredientPayload(ingredients = []) {
  return ingredients.map(({ id, pivot }) => ({ id, pivot: {
    net_content: pivot.net_content,
    net_content_unit_code: pivot.net_content_unit_code,
    can_be_excluded: pivot.can_be_excluded,
  } }));
}
